import { fetchFairProducts } from '../actions/routines';

const initialState = {
    data: [],
    loading: false,
};

const fairProducts = (state = initialState, action) => {
    switch (action.type) {
        case 'FAIR_PRODUCTS_SET':
            return { ...state };
        case fetchFairProducts.TRIGGER:
            return {
                ...state,
                loading: false,
            };
        case fetchFairProducts.SUCCESS:
            // UPDATE LATER, THE HEADERS DOESNT SHOW THE CORRECT VALUES FOR THE ALL PRODUCTS IF CART SELECTED
            return {
                ...state,
                data: action.payload.data,
                // Always update total so pagination reflects the current filter
                // (e.g. switching to "Beursmandje" must update total pages too).
                total: action.payload.total,
                countAll: action.payload.for_cart
                    ? state.countAll
                    : action.payload.countAll || state.countAll,
                countUser: action.payload.for_cart
                    ? state.countUser
                    : action.payload.countUser || state.countUser,
                countWithPromotion: action.payload.for_cart
                    ? state.countWithPromotion
                    : action.payload.countWithPromotion ||
                      state.countWithPromotion,
            };
        case fetchFairProducts.FAILURE:
            return {
                ...state,
                error: action.payload,
            };
        case fetchFairProducts.FULFILL:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
};

export default fairProducts;
